import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import Handlebars from 'handlebars';
import GenericView from 'views/generic.view.ts';
import Template from 'text-loader!../templates/forgot_password.template.htm';
import 'dhtmlxMessage';
import i18n  from "l10n";

export default GenericView.extend({
    el: $("#body"),
    tagName: 'div',
    template: Handlebars.compile(Template),
    initialize: function () {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var self = this;

        this.$el.html(this.template());
    },
    events:{
        "submit #form": "forgot",
        "keyup #email": "forgotWithEnter"
    },
    forgot: function()
    {
        var self = this;
        var email = encodeURIComponent($("#email").val());

        if(this.isEmail("#email")) {

            $.when(window.ping()).then(function(resp) {
                $.ajaxDefaultQ({
                    url: 'rest/auth/password/forgot?email=' + email,
                    type: 'POST',
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                }).done(function(response, status, xhr){
                    if(status == "success")
                    {
                        window.open('/','_self');
                    }
                })
                .fail(function(response) {
                    //console.info("Forgot Password response failed");
                    dhtmlx.alert({
                        type: "alert",
                        text: i18n.t("account.sth_wrong")+".",
                        callback: function (result) {
                            $("#email").val('');
                        }
                    });
                })
            });


        }

        return false;
    },
    forgotWithEnter: function(event)
    {
        event.preventDefault();
        if(this.isEmail("#email")) {
            if (event.keyCode == 13) {
                if($("#email").val() != null) {
                    this.forgot();
                }
            }
        }
    }
});

